import { Injectable } from "@angular/core";
import { ApiDataService } from "@services/http/ApiDataService";
import { ControlExportData } from "@app/controls/models/ControlExportData";
import { Observable, firstValueFrom } from "rxjs";

@Injectable()
export class ControlCopyEffectivenessDataService extends ApiDataService {
    constructor() {
        super("controls/testing/advanced/effectiveness/testplancopies");
    }

    public getWithGuids(guids: string[]): Observable<ControlExportData[]> {
        const formData = new FormData();
        formData.append("guids", JSON.stringify(guids));

        return this.post<ControlExportData[]>(formData);
    }

    public copyData(data: any[], newGroupName: string): Promise<void> {
        const formData = new FormData();
        formData.append("data", JSON.stringify(data));
        const url = "/copy?newGroupname=" + newGroupName;
        return firstValueFrom(this.post<void>(formData, url));
    }
}
